/**
 * app/screens/ImageManipulation.web.ts
 * ------------------------------------
 * What: Web implementation for client-side image compression using
 * `browser-image-compression`.
 * Why: Reduces upload size and speeds up transfers on the web.
 */
import imageCompression from 'browser-image-compression';

export async function manipulateImage(asset: { uri: string; fileName?: string }) {
  const fileBlob = await fetch(asset.uri).then(r => r.blob());
  // Create a clean file name without any path structure
  const fileName = `${Date.now()}_${Math.random().toString(36).substring(7)}.jpg`;
  const file = new File([fileBlob], fileName, { type: fileBlob.type });
  const compressedFile = await imageCompression(file, {
    maxWidthOrHeight: 600,
    maxSizeMB: 2,
    useWebWorker: true,
    initialQuality: 0.7,
  });
  if (compressedFile.size > 2 * 1024 * 1024) {
    throw new Error('Image too large');
  }
  return {
    uri: URL.createObjectURL(compressedFile),
    name: fileName,
    type: compressedFile.type,
    size: compressedFile.size,
  };
} 